
const findUserById = (Arrs, Id) => {
    var valObj = Arrs.filter(function(elem) {
        if (elem.id == Id) return elem;
    });
    return valObj[0];

}
const convertUnits = (productPrice,from, to,sizeVal,selling_qty) => {  

  if(to.toLowerCase() == 'l' && from.toLowerCase() == 'ml'){
    productPrice = productPrice * 1000;
  }else if(to.toLowerCase() == 'ml' && from.toLowerCase() == 'l'){
    productPrice = productPrice / 1000;
  }else if(to.toLowerCase() == 'kg' && from.toLowerCase() == 'g'){
    productPrice = productPrice * 1000;
  }else if(to.toLowerCase() == 'g' && from.toLowerCase() == 'kg'){
    productPrice = productPrice / 1000;
  }

  // console.log('productPrice1',productPrice)
  if(selling_qty == ""){
    selling_qty = 1;
  }
  
  let perUnitPrice;
  let perProductPrice = Number(productPrice)/selling_qty;
  
  perUnitPrice = perProductPrice / Number(sizeVal);

  return perUnitPrice;
}

export {
    findUserById,
    convertUnits
};